import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container", "entry"]
  static values = { nextIndex: Number }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget
    const html = template.innerHTML.replace(/__INDEX__/g, this.nextIndexValue.toString())
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    // Auto-fill UUID for any inputs marked with data-auto-uuid
    const entries = this.containerTarget.querySelectorAll("[data-nested-fields-target='entry']")
    const lastEntry = entries[entries.length - 1]
    if (lastEntry) {
      lastEntry.querySelectorAll("[data-auto-uuid]").forEach(input => {
        const uuid = crypto.randomUUID()
        input.value = uuid
        // Also set value on linked elements (e.g., radio buttons that reference this ID)
        const linkedName = input.dataset.autoUuidLink
        if (linkedName) {
          lastEntry.querySelectorAll(`[name="${linkedName}"]`).forEach(el => {
            el.value = uuid
          })
        }
      })
    }
    this.nextIndexValue++
  }

  remove(event) {
    event.preventDefault()
    const entry = event.target.closest("[data-nested-fields-target='entry']")
    if (entry) {
      entry.remove()
    }
  }
}
